import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlowComponent } from "./flow.component";
import { LogResolve } from "../log.resolve";
var FlowRoutingModule = /** @class */ (function () {
    function FlowRoutingModule() {
    }
    FlowRoutingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [RouterModule.forChild([
                            { path: 'top', loadChildren: 'app/top/top.module#TopModule', resolve: { dummy: LogResolve } },
                            {
                                path: '', component: FlowComponent,
                                resolve: { dummy: LogResolve },
                                children: [
                                    { path: ':flow', component: FlowComponent, resolve: { dummy: LogResolve } }
                                ]
                            }
                        ])],
                    exports: [RouterModule]
                },] }
    ];
    return FlowRoutingModule;
}());
export { FlowRoutingModule };
//# sourceMappingURL=flow-routing.module.js.map